import { render, staticRenderFns } from "./sw-captcha-dialog.vue?vue&type=template&id=f836cc26&scoped=true&"
import script from "./sw-captcha-dialog.vue?vue&type=script&lang=tsx&"
export * from "./sw-captcha-dialog.vue?vue&type=script&lang=tsx&"
import style0 from "./sw-captcha-dialog.vue?vue&type=style&index=0&id=f836cc26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f836cc26",
  null
  
)

export default component.exports